var map = {
	"./de/charts.js": "bf60",
	"./de/general.js": "28b8",
	"./de/inputs.js": "76ef",
	"./de/keys.js": "3395",
	"./de/menu.js": "52b4",
	"./de/messages.js": "a15d",
	"./de/titles.js": "3a5d",
	"./de/tooltip.js": "b3dc",
	"./en/charts.js": "4336",
	"./en/general.js": "513f",
	"./en/inputs.js": "aa79",
	"./en/keys.js": "796e",
	"./en/menu.js": "942d",
	"./en/messages.js": "2483",
	"./en/titles.js": "120e",
	"./en/tooltip.js": "06de",
	"./sk/charts.js": "d533",
	"./sk/general.js": "d69e",
	"./sk/inputs.js": "5445",
	"./sk/keys.js": "6ebf",
	"./sk/menu.js": "1ad9",
	"./sk/messages.js": "b1d9",
	"./sk/titles.js": "8322",
	"./sk/tooltip.js": "af6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba25";